import * as React from "react";

import {
    createStyles,
    FilledInput,
    Input,
    withStyles,
} from "@material-ui/core";

import { RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {},
        underline: {
            "&:before": {
                borderBottomStyle: "solid",
                borderBottomWidth: 1,
                borderBottomColor: theme.palette.secondary.dark,
            },
            "&:hover:not($disabled):not($error):not($focused):before": {
                borderBottomStyle: "solid",
                borderBottomWidth: 2,
                borderBottomColor: theme.palette.secondary.dark,
            },
            "&:hover:not($disabled):not($error):after": {
                borderBottomStyle: "solid",
                borderBottomWidth: 2,
                borderBottomColor: theme.palette.secondary.dark,
            },
            "&:after": {
                borderBottomStyle: "solid",
                borderBottomWidth: 2,
                borderBottomColor: theme.palette.secondary.dark,
            },
        },
        disabled: {},
        error: {},
        focused: {},
    });

export const StyledInput = withStyles(styles, {
    name: "StyledInput",
    withTheme: true,
})(Input);
